import Modal from "./../Modal";
import {ITestheftvarianten} from "../Interfaces";
import Veraportal from "./../Veraportal";
import Utilities from "./../Utilities";
import {IGruppenDB, ISchuelerDB} from "../InterfacesDB";
import VeraApi from "./../VeraApi";
import Tooltip from '../Tooltip';

export default class StammklasseAnpassenModal extends Modal {
    private aktuelleGruppe: IGruppenDB = null;

    public constructor(veraportal: Veraportal, aktuelleGruppeId: number = null) {
        super(veraportal);

        this.aktuelleGruppe = this._veraportal.gruppenliste.filter((g) => {
            return g.gruppe_id === aktuelleGruppeId
        })[0] ?? null;
    }

    protected override modalMain() {
        const isDG = this._veraportal.sessionvariablen.schule.land === 'dg';
        const isVera5 = this._veraportal.sessionvariablen.projekt.weiche === 'vera5';
        const kurssystemTooltip = Tooltip.html`
            <p><strong>Unterricht im Kurssystem</strong></p>
            <p>Wenn nicht alle Schülerinnen und Schüler dieser Stammklasse im Fach gemeinsam auf demselben Differenzierungsniveau unterrichtet werden, legen Sie Kurse an und ordnen ihnen die Schülerinnen und Schüler zu.</p>
            <p>Das Testheft wird anschließend durch den jeweiligen Kurs bestimmt.</p>
        `;
        this.mainHTML = `
        <main>   
            ${(this.aktuelleGruppe === null) ? `
                <p>
                    Um eine neue Stammklasse anzulegen, wählen Sie deren Bezeichnung.<br/>
                    Sie können durch Eingabe der Klassengröße auch direkt zusätzliche Schüler
                    anlegen und für die gesamte Gruppe Testhefte auswählen.
                    Möchten sie Eigenschaften nachträglich ändern, können Sie neben eine Stammklasse auf das Zahnrad-Icon klicken.
                </p>
            ` : `
                <p>
                    Die Anpassung der Stammklassen-Eigenschaften führt dazu, dass Ihre Eingaben
                    überall im Portal aktualisiert werden. Auch die Testheftzuordnung für alle zur
                    Stammklasse gehörigen Schüler lässt sich so korrigieren.
                </p>
            `}

            ${(this._veraportal.sessionvariablen.schule.land === 'rp') ? `
                <p>
                    In den Fächern Mathematik, Deutsch und Englisch stehen durch die Modularisierung der Testmaterialien (Basis- und Ergänzungsmodule)
                    drei Testheftvarianten zur Verfügung. Es wird ein am jeweiligen Bildungsgang (Niveau) orientierter Einsatz der Testheftvarianten empfohlen.<br/>
                    Für Lerngruppen, die den Bildungsgang <i>Berufsreife</i> anstreben, gilt Testheft A. Lerngruppen, die den Bildungsgang <i>Qualifizierten Sekundarabschuss I</i>
                    anstreben, das Testheft B. Für Lerngruppen mit darüber hinausgehenden Abschlusszielen Testheft C.
                </p>` : ``}

            ${(this._veraportal.sessionvariablen.schule.land === 'sl') ? `
                <p>
                    In Deutsch und Mathematik stehen durch die Modularisierung der Testmaterialien (Basis- und Ergänzungsmodule) künftig wieder drei 
                    Testheftvarianten zur Verfügung. Dabei werden die <b>Testhefte A und B in den Gemeinschaftsschulen</b> und <b>Testheft C im Gymnasium</b> eingesetzt. 
                    In den Gemeinschaftsschulen sollen in den G-Kursen Testheft A und in den E-Kursen Testheft B eingesetzt werden.
                </p>` : ``}
            
            <div class="stammklasse-anlegen">
                <div class="allgemeine-eigenschaften">
                    <div>
                        <label for="samodal-bezeichnung"
                        data-tooltip="${Tooltip.html`
                            <p><strong>Stammklassenbezeichnung</strong></p>
                            <p>Wählen Sie eine Bezeichnung, die während des ${this._veraportal.sessionvariablen.projekt.bezeichnung}-Durchgangs nachvollziehbar bleibt. Doppelte Bezeichnungen und exotische Sonderzeichen sind nicht zulässig.</p>
                        `}">
                            Bezeichnung:<br/>
                            <input type="text" id="samodal-bezeichnung" size="20" maxlength="16" placeholder="z.B. 8a"
                            value="${(this.aktuelleGruppe !== null) ? this.aktuelleGruppe.bezeichnung : ''}"
                            />
                        </label>
                    </div>
                    ${(this._veraportal.sessionvariablen.schule.land !== 'ni') ? `
                    <div class="schueler-anlegen-checkbox">
                        <label for="samodal-schueler-anlegen"
                        data-tooltip="${Tooltip.html`
                            <p><strong>Direkt Schülerinnen und Schüler anlegen</strong></p>
                            <p>Die angegebene Anzahl wird neu angelegt und automatisch dieser Stammklasse zugeordnet.</p>
                            <p>Ohne diese Option wird nur die Stammklasse erstellt. Zuordnungen können später in der Schülerverwaltung erfolgen.</p>
                        `}">
                            <span class="verschieben">direkt neue<br/>Schüler anlegen</span>
                            <input type="checkbox" id="samodal-schueler-anlegen" checked="checked"/>
                        </label>
                    </div>
                    ` : ``}
                    <div class="schueler-anlegen">
                        <label for="samodal-anzahl"
                        data-tooltip="${Tooltip.html`
                            <p><strong>Klassengröße</strong></p>
                            <p>Wie viele Schülerinnen und Schüler sollen erstellt und der neuen Stammklasse zugeordnet werden?</p>
                        `}">
                            Klassengröße:<br/>
                            <input type="text" id="samodal-anzahl" maxlength="2" size="6" placeholder="z.B. 18"/>
                        </label>
                    </div>
                </div>
                <div class="testhefte ${(this._veraportal.sessionvariablen.schule.land === 'ni') ? `disabled` : ``}">
                    <div class="mathematik ${(this._veraportal.sessionvariablen.schule.teilnahme_mathematik === 0) ? `disabled` : ``}">
                        <div class="ueberschrift">Mathematik ${(this._veraportal.sessionvariablen.schule.teilnahme_mathematik === 2) ? `(freiwillig)` : ``}:</div>
                        <select class="testheft" id="samodal-th-mathematik">
                            ${!isDG ? `<option value="-" ${(isVera5 === false || this.aktuelleGruppe?.testheft_mathematik === null) ? `selected` : ``}>kein Testheft</option>` : ``}
        ${this._veraportal.testheftVarianten.filter((t) => {
            return t.fach === 'ma'
        }).map((v: ITestheftvarianten & { selected: boolean }) => {
            if (this.aktuelleGruppe === null) {
                v.selected = isVera5;
            } else {
                v.selected = isVera5 ? this.aktuelleGruppe.testheft_mathematik !== null : (
                    this.aktuelleGruppe.testheft_mathematik === v.testheft_id &&
                    this.aktuelleGruppe.is_cbt_mathematik === ((v.cbt) ? 1 : 0)
                );
            }
            return v;
        }).map(this._veraportal.testheftOptionHTML).join('')}
                        </select>
                         <label for="samodal-mathematik-kurssystem"  style="${isDG ? 'display:none' : ''}"
                         data-tooltip="${kurssystemTooltip}">
                            in Kursen unterrichtet
                            <input type="checkbox" class="kursunterricht" id="samodal-mathematik-kurssystem"  ${isDG ? 'disabled' : ''} ${(this.aktuelleGruppe?.testheft_mathematik === null) ? `checked="checked"` : ``}/>
                    </div>
                    <div class="deutsch ${(this._veraportal.sessionvariablen.schule.teilnahme_deutsch === 0) ? `disabled` : ``}">
                        <div class="ueberschrift">Deutsch ${(this._veraportal.sessionvariablen.schule.teilnahme_deutsch === 2) ? `(freiwillig)` : ``}:</div>
                        <select class="testheft" id="samodal-th-deutsch">
                            <option value="-" ${(isVera5 === false || this.aktuelleGruppe?.testheft_deutsch === null) ? `selected` : ``}>kein Testheft</option>
        ${this._veraportal.testheftVarianten.filter((t) => {
            return t.fach === 'de'
        }).map((v: ITestheftvarianten & { selected: boolean }) => {
            if (this.aktuelleGruppe === null) {
                v.selected = isVera5;
            } else {
                v.selected = isVera5 ? this.aktuelleGruppe.testheft_deutsch !== null : (
                    this.aktuelleGruppe.testheft_deutsch === v.testheft_id &&
                    this.aktuelleGruppe.is_cbt_deutsch === ((v.cbt) ? 1 : 0)
                );
            }
            return v;
        }).map(this._veraportal.testheftOptionHTML).join('')}
                        </select>
                        <label for="samodal-deutsch-kurssystem"
                        data-tooltip="${kurssystemTooltip}">
                            in Kursen unterrichtet
                            <input type="checkbox" class="kursunterricht" id="samodal-deutsch-kurssystem" ${(this.aktuelleGruppe?.testheft_deutsch === null) ? `checked="checked"` : ``}/>
                        </label>
                    </div>
                    <div class="englisch ${(this._veraportal.sessionvariablen.schule.teilnahme_englisch === 0) ? `disabled` : ``}">
                        <div class="ueberschrift">Englisch ${(this._veraportal.sessionvariablen.schule.teilnahme_englisch === 2) ? `(freiwillig)` : ``}:</div>
                        <select class="testheft" id="samodal-th-englisch">
                            <option value="-" ${(isVera5 === false || this.aktuelleGruppe?.testheft_englisch === null) ? `selected` : ``}>kein Testheft</option>
        ${this._veraportal.testheftVarianten.filter((t) => {
            return t.fach === 'en'
        }).map((v: ITestheftvarianten & { selected: boolean }) => {
            if (this.aktuelleGruppe === null) {
                v.selected = isVera5;
            } else {
                v.selected = isVera5 ? this.aktuelleGruppe.testheft_englisch !== null : (
                    this.aktuelleGruppe.testheft_englisch === v.testheft_id &&
                    this.aktuelleGruppe.is_cbt_englisch === ((v.cbt) ? 1 : 0)
                );
            }
            return v;
        }).map(this._veraportal.testheftOptionHTML).join('')}
                        </select>
                        <label for="samodal-englisch-kurssystem"
                        data-tooltip="${kurssystemTooltip}">
                            in Kursen unterrichtet
                            <input type="checkbox" class="kursunterricht" id="samodal-englisch-kurssystem" ${(this.aktuelleGruppe?.testheft_englisch === null) ? `checked="checked"` : ``}/>
                        </label>
                    </div>
                    <div class="franzoesisch ${(this._veraportal.sessionvariablen.schule.teilnahme_franzoesisch === 0) ? `disabled` : ``}">
                        <div class="ueberschrift">Französisch ${(this._veraportal.sessionvariablen.schule.teilnahme_franzoesisch === 2 && this._veraportal.sessionvariablen.schule.land !== 'rp') ? `(freiwillig)` : ``}:</div>
                        <select class="testheft" id="samodal-th-franzoesisch">
                            <option value="-" ${(isVera5 === false || this.aktuelleGruppe?.testheft_franzoesisch === null) ? `selected` : ``}>kein Testheft</option>
        ${this._veraportal.testheftVarianten.filter((t) => {
            return t.fach === 'fr'
        }).map((v: ITestheftvarianten & { selected: boolean }) => {
            if (this.aktuelleGruppe === null) {
                v.selected = isVera5;
            } else {
                v.selected = isVera5 ? this.aktuelleGruppe.testheft_franzoesisch !== null : (
                    this.aktuelleGruppe.testheft_franzoesisch === v.testheft_id &&
                    this.aktuelleGruppe.is_cbt_franzoesisch === ((v.cbt) ? 1 : 0)
                );
            }
            return v;
        }).map(this._veraportal.testheftOptionHTML).join('')}
                        </select>
                        <label for="samodal-franzoesisch-kurssystem"
                        data-tooltip="${kurssystemTooltip}">
                            in Kursen unterrichtet
                            <input type="checkbox" class="kursunterricht" id="samodal-franzoesisch-kurssystem" ${(this.aktuelleGruppe?.testheft_franzoesisch === null) ? `checked="checked"` : ``}/>
                        </label>
                    </div>
                </div>
            </div>
        </main>
        `;
    }

    override async init(): Promise<void> {
        await this._veraportal.lifecycleLeave(); // mit Öffnung des Fensters Schüler übertragen

        // Überschrift und Buttonbeschriftung ändern, wenn Editierung statt neu anlegen
        if (this.aktuelleGruppe !== null) {
            document.querySelector(`#modal-stammklasse-anpassen > article > header > h3`)
                .innerHTML = `Stammklassen-Eigenschaften von '${this.aktuelleGruppe.bezeichnung}' ändern
                <button id="samodal-gruppe-loeschen-btn">
                    <svg role="graphics-symbol">
                        <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#trash"/>
                    </svg>
                Stammklasse löschen
                </button>`;

            document.querySelector(`#modal-stammklasse-anpassen > article > footer > button.submit`)
                .innerHTML = `Speichern`;
        }

        // Eingabebeschraenkungen Textfelder
        document.querySelector(`#samodal-bezeichnung`).addEventListener('keyup', (evt) => {
            Utilities.forceKeys(evt.target as HTMLInputElement, 'A-Za-z0-9äÄüÜöÖß\\-\\_\\ \\.', false, true);
        });
        document.querySelector(`#samodal-anzahl`).addEventListener('keyup', (evt) => {
            Utilities.forceKeys(evt.target as HTMLInputElement, '0-9', false, false);
        });

        // Tom-Select Initialisierungen
        try {
            document.querySelectorAll(`#modal-stammklasse-anpassen select.testheft`)
                .forEach((ui) => {
                    // @ts-ignore
                    new TomSelect(`#${ui.id}`, this._veraportal.tsTestheftOptions);
                });
        } catch {
            //
        }

        // Schüler anlegen Checkbox State-Check
        const modalSchuelerAnlegenState = () => {
            if (
                this.aktuelleGruppe !== null ||
                (document.querySelector(`#samodal-schueler-anlegen`) as HTMLInputElement)?.checked === true ||
                this._veraportal.sessionvariablen.schule.land === 'ni'
            ) {
                document.querySelector(`#modal-stammklasse-anpassen div.schueler-anlegen`)
                    ?.classList.add('active');
            } else {
                document.querySelector(`#modal-stammklasse-anpassen div.schueler-anlegen`)
                    ?.classList.remove('active');
            }
        };
        modalSchuelerAnlegenState();
        document.querySelector(`#samodal-schueler-anlegen`)
            ?.addEventListener('change', () => modalSchuelerAnlegenState());

        // "Schüler hinzufügen"-Bereich ausblenden, wenn Stammklasse editiert wird
        if (this.aktuelleGruppe !== null) {
            document.querySelector(`#modal-stammklasse-anpassen div.schueler-anlegen`)
                ?.classList.add('hidden');
            document.querySelector(`#modal-stammklasse-anpassen div.schueler-anlegen-checkbox`)
                ?.classList.add('hidden');
        }

        //region Mathematik Kurssystem State-Check
        const modalKurssystemStateMathematik = () => {
            if (
                (document.querySelector(`#samodal-mathematik-kurssystem`) as HTMLInputElement)?.checked === true ||
                this._veraportal.sessionvariablen.schule.land === 'ni'
            ) {
                // @ts-ignore
                document.querySelector(`#samodal-th-mathematik`).tomselect.setValue('-');
                // @ts-ignore
                document.querySelector(`#samodal-th-mathematik`).tomselect.disable();
            } else {
                if (this._veraportal.sessionvariablen.projekt.weiche === 'vera5') {
                    const testheft = this._veraportal.testheftVarianten.find((t) => t.fach === 'ma');
                    // @ts-ignore
                    document.querySelector(`#samodal-th-mathematik`).tomselect.setValue(`${testheft?.testheft_id}cbt`);
                    // @ts-ignore
                    document.querySelector(`#samodal-th-mathematik`).tomselect.disable();
                } else {
                    // @ts-ignore
                    document.querySelector(`#samodal-th-mathematik`).tomselect.enable();
                }
            }
        };
        modalKurssystemStateMathematik();
        document.querySelector(`#samodal-mathematik-kurssystem`).addEventListener('change', () => {
            modalKurssystemStateMathematik();
        });
        //endregion

        //region Deutsch Kurssystem State-Check
        const modalKurssystemStateDeutsch = () => {
            if (
                (document.querySelector(`#samodal-deutsch-kurssystem`) as HTMLInputElement)?.checked === true ||
                this._veraportal.sessionvariablen.schule.land === 'ni'
            ) {
                // @ts-ignore
                document.querySelector(`#samodal-th-deutsch`).tomselect.setValue('-');
                // @ts-ignore
                document.querySelector(`#samodal-th-deutsch`).tomselect.disable();
            } else {
                if (this._veraportal.sessionvariablen.projekt.weiche === 'vera5') {
                    const testheft = this._veraportal.testheftVarianten.find((t) => t.fach === 'de');
                    // @ts-ignore
                    document.querySelector(`#samodal-th-deutsch`).tomselect.setValue(`${testheft?.testheft_id}cbt`);
                    // @ts-ignore
                    document.querySelector(`#samodal-th-deutsch`).tomselect.disable();
                } else {
                    // @ts-ignore
                    document.querySelector(`#samodal-th-deutsch`).tomselect.enable();
                }
            }
        };
        modalKurssystemStateDeutsch();
        document.querySelector(`#samodal-deutsch-kurssystem`).addEventListener('change', () => {
            modalKurssystemStateDeutsch();
        });
        //endregion

        //region Englisch Kurssystem State-Check
        const modalKurssystemStateEnglisch = () => {
            if (
                (document.querySelector(`#samodal-englisch-kurssystem`) as HTMLInputElement)?.checked === true ||
                this._veraportal.sessionvariablen.schule.land === 'ni'
            ) {
                // @ts-ignore
                document.querySelector(`#samodal-th-englisch`).tomselect.setValue('-');
                // @ts-ignore
                document.querySelector(`#samodal-th-englisch`).tomselect.disable();
            } else {
                if (this._veraportal.sessionvariablen.projekt.weiche === 'vera5') {
                    const testheft = this._veraportal.testheftVarianten.find((t) => t.fach === 'en');
                    // @ts-ignore
                    document.querySelector(`#samodal-th-englisch`).tomselect.setValue(`${testheft?.testheft_id}cbt`);
                    // @ts-ignore
                    document.querySelector(`#samodal-th-englisch`).tomselect.disable();
                } else {
                    // @ts-ignore
                    document.querySelector(`#samodal-th-englisch`).tomselect.enable();
                }
            }
        };
        modalKurssystemStateEnglisch();
        document.querySelector(`#samodal-englisch-kurssystem`).addEventListener('change', () => {
            modalKurssystemStateEnglisch();
        });
        //endregion

        //region Franzoesisch Kurssystem State-Check
        const modalKurssystemStateFranzoesisch = () => {
            if (
                (document.querySelector(`#samodal-franzoesisch-kurssystem`) as HTMLInputElement)?.checked === true ||
                this._veraportal.sessionvariablen.schule.land === 'ni'
            ) {
                // @ts-ignore
                document.querySelector(`#samodal-th-franzoesisch`).tomselect.setValue('-');
                // @ts-ignore
                document.querySelector(`#samodal-th-franzoesisch`).tomselect.disable();
            } else {
                if (this._veraportal.sessionvariablen.projekt.weiche === 'vera5') {
                    const testheft = this._veraportal.testheftVarianten.find((t) => t.fach === 'fr');
                    // @ts-ignore
                    document.querySelector(`#samodal-th-franzoesisch`).tomselect.setValue(`${testheft?.testheft_id}cbt`);
                    // @ts-ignore
                    document.querySelector(`#samodal-th-franzoesisch`).tomselect.disable();
                } else {
                    // @ts-ignore
                    document.querySelector(`#samodal-th-franzoesisch`).tomselect.enable();
                }
            }
        };
        modalKurssystemStateFranzoesisch();
        document.querySelector(`#samodal-franzoesisch-kurssystem`).addEventListener('change', () => {
            modalKurssystemStateFranzoesisch();
        });
        //endregion

        if (this.aktuelleGruppe !== null) {
            // Löschen-Button Klick-Event
            document.querySelector(`#samodal-gruppe-loeschen-btn`).addEventListener('click', () => {
                let loeschenModal = new Modal(this._veraportal);
                let loeschenModalPromise = loeschenModal.show({
                    title: `Möchten Sie die Stammklasse '${this.aktuelleGruppe.bezeichnung}' wirklich löschen?`,
                    body: `<p>Möchten Sie die Stammklasse '${this.aktuelleGruppe.bezeichnung}' wirklich löschen?</p>
                    <p>Nur Gruppen ohne zugeordnete Schüler können gelöscht werden. Entfernen Sie zuerst alle Zuordnungen.</p>
                    <p>Um die Stammklasse wirklich zu löschen, geben Sie im Feld unten <i>"OK"</i> ein und betätigen Sie mit "Stammklasse löschen".</p>`,
                    hasSubmit: true,
                    hasCancel: true,
                    hasBestaetigung: true,
                    width: 700,
                    cancelText: 'Abbrechen',
                    submitText: 'Stammklasse löschen'
                });
                loeschenModalPromise.then(async (modalantwort) => {
                    if (modalantwort === true) {
                        try {
                            const api = VeraApi.getInstance(this._veraportal);
                            let deleteGruppeResponse = await api.deleteGruppe([{gruppe_id: this.aktuelleGruppe.gruppe_id ?? null}]);
                            if (deleteGruppeResponse === true) {
                                //TODO:medium Ansichten neu laden ohne kompleten Page-Reload
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }
                        } catch {
                            //
                        }
                    }
                });
            });
        }
    }

    override validation(): boolean {
        //region Gruppenbezeichnung prüfen
        let gruppenbezeichnung: string = (document.querySelector(`#samodal-bezeichnung`) as HTMLInputElement)?.value.trim();
        if (gruppenbezeichnung.length < 2) {
            let modal = new Modal(this._veraportal);
            modal.show({
                title: `Stammklassenbezeichnung unzureichend`,
                body: `<p>Die Bezeichnung Ihrer neuen Stammklasse muss mindestens zwei Zeichen lang sein und darf keine Sonderzeichen enthalten.</p>`,
                hasSubmit: false,
                hasCancel: true,
                hasBestaetigung: false,
                width: 400,
                cancelText: 'OK'
            });
            return false;
        }
        if (this.aktuelleGruppe === null && this._veraportal.gruppenliste.map(g => g.bezeichnung.toLowerCase()).includes(gruppenbezeichnung.toLowerCase())) {
            let modal = new Modal(this._veraportal);
            modal.show({
                title: `Gruppenbezeichnung bereits vergeben`,
                body: `<p>Die Bezeichnung Ihrer neuen Stammklasse darf nicht bereits bei einer anderen Gruppe Ihres Jahrganges verwendet werden.</p>`,
                hasSubmit: false,
                hasCancel: true,
                hasBestaetigung: false,
                width: 400,
                cancelText: 'OK'
            });
            return false;
        }
        //endregion

        //region Testheftzuordnung prüfen
        let thIdMathematik: string = (document.querySelector(`select#samodal-th-mathematik`) as HTMLInputElement).value ?? '-';
        let thIdDeutsch: string = (document.querySelector(`select#samodal-th-deutsch`) as HTMLInputElement).value ?? '-';
        let thIdEnglisch: string = (document.querySelector(`select#samodal-th-englisch`) as HTMLInputElement).value ?? '-';
        let thIdFranzoesisch: string = (document.querySelector(`select#samodal-th-franzoesisch`) as HTMLInputElement).value ?? '-';

        // wenn Kurssystem-Checkbox nicht gesetzt, aber trotzdem kein TH in diesem Fach gewählt wurde
        if (this._veraportal.sessionvariablen.schule.land !== 'ni' &&
            (
                (
                    (this._veraportal.sessionvariablen.schule.teilnahme_mathematik === 1) &&
                    ((document.querySelector(`#samodal-mathematik-kurssystem`) as HTMLInputElement)?.checked ?? false) === false &&
                    thIdMathematik === '-'
                ) ||
                (
                    (this._veraportal.sessionvariablen.schule.teilnahme_deutsch === 1) &&
                    ((document.querySelector(`#samodal-deutsch-kurssystem`) as HTMLInputElement)?.checked ?? false) === false &&
                    thIdDeutsch === '-'
                ) ||
                (
                    (this._veraportal.sessionvariablen.schule.teilnahme_englisch === 1) &&
                    ((document.querySelector(`#samodal-englisch-kurssystem`) as HTMLInputElement)?.checked ?? false) === false &&
                    thIdEnglisch === '-'
                ) ||
                (
                    (this._veraportal.sessionvariablen.schule.teilnahme_franzoesisch === 1) &&
                    ((document.querySelector(`#samodal-franzoesisch-kurssystem`) as HTMLInputElement)?.checked ?? false) === false &&
                    thIdFranzoesisch === '-'
                )
            )
        ) {
            let hinweisModal = new Modal(this._veraportal);
            hinweisModal.show({
                title: `Kein Testheft ausgewählt`,
                body: `<p>
                        In
                ${Utilities.printFachLang([
                    (this._veraportal.sessionvariablen.schule.teilnahme_mathematik === 1) ? 'ma' : null,
                    (this._veraportal.sessionvariablen.schule.teilnahme_deutsch === 1) ? 'de' : null,
                    (this._veraportal.sessionvariablen.schule.teilnahme_englisch === 1) ? 'en' : null,
                    (this._veraportal.sessionvariablen.schule.teilnahme_franzoesisch === 1) ? 'fr' : null
                ])}
                        müssen verpflichtend Testhefte ausgewählt werden,
                        sofern die Schüler in diesem Fach nicht in Kursen unterrichtet werden.<br/>
                        Die Kurse sollten Sie dann anschließend über die entsprechende Schaltfläche anlegen und im darauf folgenden Schritt über die
                        Schüler-Verwaltung SuS den Kursen zuordnen.
                        </p>`,
                hasSubmit: false,
                hasCancel: true,
                hasBestaetigung: false,
                width: 500,
                cancelText: 'OK'
            });
            return false;
        }
        //endregion

        // wenn direkt neue Schüler hinzugefügt werden sollen (Checkbox)
        if (
            this.aktuelleGruppe === null &&
            (
                (document.querySelector(`#samodal-schueler-anlegen`) as HTMLInputElement)?.checked === true ||
                this._veraportal.sessionvariablen.schule.land === 'ni'
            )
        ) {
            // Schüleranzahl prüfen
            let schuelerAnzahl: number = parseInt((document.querySelector(`#samodal-anzahl`) as HTMLInputElement)?.value ?? '0');
            if (schuelerAnzahl < 1 || schuelerAnzahl > 50 || isNaN(schuelerAnzahl)) {
                let hinweisModal = new Modal(this._veraportal);
                hinweisModal.show({
                    title: `Anzahl Schüler in Stammklasse unzulässig`,
                    body: `<p>Ihre Stammklassengröße sollte zwischen einem und 50 Schüler enthalten.<br/>
                            Enthält Ihre Stammklasse wirklich mehr als 50 Schüler, können Sie diese über die
                            Schüler-Verwaltung separat der Stammklasse hinzufügen.</p>`,
                    hasSubmit: false,
                    hasCancel: true,
                    hasBestaetigung: false,
                    width: 300,
                    cancelText: 'OK'
                });
                return false;
            }
        }

        return true;
    }

    protected antwortHandler(antwortPromise: Promise<any>): Promise<any> {
        antwortPromise.then(async (promiseValue) => {
            if (promiseValue !== true) return;

            let thValueMathematik: string = (document.querySelector(`select#samodal-th-mathematik`) as HTMLInputElement).value ?? '-';
            let thValueDeutsch: string = (document.querySelector(`select#samodal-th-deutsch`) as HTMLInputElement).value ?? '-';
            let thValueEnglisch: string = (document.querySelector(`select#samodal-th-englisch`) as HTMLInputElement).value ?? '-';
            let thValueFranzoesisch: string = (document.querySelector(`select#samodal-th-franzoesisch`) as HTMLInputElement).value ?? '-';

            let changedGruppenArr: IGruppenDB[] = [];
            changedGruppenArr.push({
                typ: 'STAMMKLASSE',
                gruppe_id: (this.aktuelleGruppe !== null) ? this.aktuelleGruppe.gruppe_id : null,
                bezeichnung: (document.querySelector(`#samodal-bezeichnung`) as HTMLInputElement).value.trim(),
                testheft_mathematik: (thValueMathematik !== '-') ? parseInt(thValueMathematik) : null,
                testheft_deutsch: (thValueDeutsch !== '-') ? parseInt(thValueDeutsch) : null,
                testheft_englisch: (thValueEnglisch !== '-') ? parseInt(thValueEnglisch) : null,
                testheft_franzoesisch: (thValueFranzoesisch !== '-') ? parseInt(thValueFranzoesisch) : null,
                is_cbt_mathematik: (thValueMathematik.indexOf('cbt') !== -1) ? 1 : 0,
                is_cbt_deutsch: (thValueDeutsch.indexOf('cbt') !== -1) ? 1 : 0,
                is_cbt_englisch: (thValueEnglisch.indexOf('cbt') !== -1) ? 1 : 0,
                is_cbt_franzoesisch: (thValueFranzoesisch.indexOf('cbt') !== -1) ? 1 : 0
            });

            const api = VeraApi.getInstance(this._veraportal);
            let responseGruppenApi = await api.postGruppe(changedGruppenArr);

            //region Schüler direkt anlegen und hinzufügen
            if (
                responseGruppenApi.length > 0 &&
                this.aktuelleGruppe === null &&
                (
                    (document.querySelector(`#samodal-schueler-anlegen`) as HTMLInputElement)?.checked === true ||
                    this._veraportal.sessionvariablen.schule.land === 'ni'
                )
            ) {
                // leere SuS anlegen
                let responseSchuelerApi: ISchuelerDB[] = await api.postEmptySchuelers(
                    parseInt((document.querySelector(`#samodal-anzahl`) as HTMLInputElement)?.value ?? '0')
                );

                // SuS in die neue Gruppe zuweisen
                if (responseSchuelerApi.length > 0) {
                    await api.postSchuelerGruppenZuweisungen(
                        responseSchuelerApi.map(s => {
                            return {
                                schueler_id: s.schueler_id,
                                gruppe_id: responseGruppenApi[0].gruppe_id
                            }
                        })
                    );
                }
            }
            //endregion

            await Utilities.delay(1000);
            window.location.reload();
        });
        return antwortPromise;
    }
}
